import { useQuery, gql, type QueryResult } from '@apollo/react-hooks';
import { getFinding } from '#/graphql/queries';
import type { GetFindingQuery } from '#/graphql/types';

export const GET_FINDING = gql(getFinding);

const useFindingQuery = (id?: string) => {
  const query: QueryResult<GetFindingQuery> = useQuery(GET_FINDING, {
    variables: { id },
    skip: !id || id === 'new',
    fetchPolicy: 'cache-and-network',
  });

  return query;
};

export default useFindingQuery;
